import React from 'react';
import PropTypes from 'prop-types';
import DrawerAnchor from './DrawerAnchor';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';

ResponsiveDrawerAnchor.propTypes = {
	width: PropTypes.object,
	isMobile: PropTypes.func,
	renderDrawerContent: PropTypes.func,
	header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

ResponsiveDrawerAnchor.defaultProps = {
	width: { mobile: '100%', desktop: '700px' },
};

function ResponsiveDrawerAnchor({
	width,
	isMobile,
	children,
	renderDrawerContent,
	header,
}) {
	const isMobileSize = isMobile();
	return (
		<DrawerAnchor
			closable={isMobileSize}
			width={isMobileSize ? width.mobile : width.desktop}
			placement={isMobileSize ? 'bottom' : 'left'}
			height={isMobileSize ? '90%' : '100%'}
			title={header}
			renderDrawerContent={renderDrawerContent}>
			{children}
		</DrawerAnchor>
	);
}

export default withIsMobile(ResponsiveDrawerAnchor);
